import { render, staticRenderFns } from "./partIdPreview.vue?vue&type=template&id=2a08f251&scoped=true&"
import script from "./partIdPreview.vue?vue&type=script&lang=js&"
export * from "./partIdPreview.vue?vue&type=script&lang=js&"
import style0 from "./partIdPreview.vue?vue&type=style&index=0&id=2a08f251&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08f251",
  null
  
)

export default component.exports